import React from 'react';

const WizardProgress = ({ currentStep, totalSteps }) => {
    const stepLabels = ['Basic Info', 'Contact', 'Services', 'About', 'Review'];

    return (
        <div className="wizard-progress">
            <div className="progress-bar">
                <div
                    className="progress-fill"
                    style={{ width: `${(currentStep / totalSteps) * 100}%` }}
                />
            </div>
            <div className="progress-steps">
                {[...Array(totalSteps)].map((_, index) => (
                    <div
                        key={index}
                        className={`progress-step ${index + 1 <= currentStep ? 'active' : ''}`}
                        title={stepLabels[index]}
                    >
                        {index + 1}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WizardProgress;
